import React from 'react';
import Select from 'react-select';
import { Collapse, UncontrolledCollapse, Button, CardBody, Card, CardHeader, CardText, CardTitle, Row, Col, Spinner } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink, Alert } from 'reactstrap';
import './css/Delegar.css';
import Image from 'react-bootstrap/Image';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './css/fonts.css';
import { AppContext } from './../AppContext';
import url from './variables/url.js';
const local = url.localBack;

const MySwal = withReactContent(Swal)
const fechaInicioSub = process.env.REACT_APP_FECHA_INICIO_SUB;
const fechaFinSub = process.env.REACT_APP_FECHA_FIN_SUB;
const currentDate = new Date();

function importAll(r) {
    let images = {};
    r.keys().forEach((item, index) => { images[item.replace('./', '')] = r(item); });
    return images
}

const images = importAll(require.context('./icons', false, /\.(png|jpe?g|svg)$/));

class Delegar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            profesores: [],
            coordinadores: [],
            asignados: [],
            loading: true,
            profesoresMutar: [],
            coordinador: { label: 'Elija el coordinador', value: 0, programa: 0, idPersona: 0 },
            marcados: [],
            totalPageP: 0,
            actualPage: 1,            
            siblingCount: 1,
            currentPage: 1,
            currentTotalPages: 0,
            postsActividad: [],
            respItems: -1,
            postsPerPage: 10,
            block: false,
            bandera: false, banderaDec: false, banderaVice: false
        };
        this.toggleChange = this.toggleChange.bind(this);
        this.marcados = [];

        fetch(local + 'Validacion/Getapplaw', {
            method: 'GET'
        }).then(response => response.json())
            .then(data => {
                //console.log("leyes", data)
                //console.log("leyesInicio", data.fecha_inicio_sub)
                //console.log("leyesFin", data.fecha_fin_sub)
                let banSub = currentDate > this.changeFormat(data.fecha_inicio_sub) && currentDate < this.changeFormat(data.fecha_fin_sub)
                let banDec = currentDate > this.changeFormat(data.fecha_inicio_dec) && currentDate < this.changeFormat(data.fecha_fin_dec)
                let banVice = currentDate > this.changeFormat(data.fecha_inicio_vice) && currentDate < this.changeFormat(data.fecha_fin_vice)
                this.setState({ bandera: banSub, banderaDec: banDec, banderaVice: banVice })
            }).catch(function F(error) {
                console.log(error);
            });
    }

    componentDidMount() {
        let currentUser = this.context
        /*console.log("current");*/
        if (currentUser != null) {
            if (currentUser.roles.includes('SUBDECANO')) {
                this.populate();
            } else {
                this.isForbidden();
            }
        }
    }

    componentDidUpdate() {
        let currentUser = this.context
        /*console.log("current");*/
        if (currentUser != null && this.state.coordinadores.length === 0) {
            if (currentUser.roles.includes('SUBDECANO')) {                
                this.populate();
            } else {
                this.isForbidden();
            }            
        }
    }

    isForbidden() {
        this.props.history.push({
            pathname: '/',
        })
    }

    setPagePrevious() {
        if (this.state.currentPage !== 1) {
            let p = this.state.currentPage;
            this.setState({
                currentPage: p - 1
            });
        }
    }

    setPageNext() {
        if (this.state.currentPage !== this.state.totalPageP) {
            let p = this.state.currentPage;
            this.setState({
                currentPage: p + 1
            });
        }
    }

    setPage = (pageNum) => {
        this.setState({ currentPage: pageNum })
    }

    setYouAreMySibling(num) {
        let actualPage = this.state.currentPage;
        let sibling = this.state.siblingCount;
        let total = this.state.totalPageP;
        let valor = false;
        if (num === actualPage || num - sibling === actualPage || num + sibling === actualPage) {
            valor = true;
        }
        if (actualPage === 1 && (num - 1 === actualPage || num - 2 === actualPage || num - 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === 2 && (num - 1 === actualPage || num - 2 === actualPage)) {
            valor = true;
        }
        if (actualPage === total && (num + 1 === actualPage || num + 2 === actualPage || num + 3 === actualPage)) {
            valor = true;
        }
        if (actualPage === total - 1 && (num + 1 === actualPage || num + 2 === actualPage)) {
            valor = true;
        }
        return valor;
    }

    reLoadTotalPage(lenActividades, limite) {
        this.setState({ totalPageP: Math.ceil(lenActividades / limite), actualPage: 1, currentPage: 1 });

    }

    populate() {
        /*console.log("Populate")*/
        fetch(local + 'Validacion/DelegacionInfo', {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => {
                /*console.log(data);*/
                this.setState({
                    profesores: data.profesores, coordinadores: data.coordinadores, asignados: data.usuarioAsignado, loading: false, profesoresMutar: data.profesores,
                    marcados: data.usuarioAsignado.length > 0 ? data.usuarioAsignado.map(({ valDetalle }) => valDetalle).flat() : []
                })
                this.reLoadTotalPage(this.state.profesoresMutar.length, this.state.postsPerPage);
            })
            .catch(function F(error) {
                console.log(error);
            })
    }

    handleCoordinadorChange = (coor) => {
        /*console.log(coor)*/
        if (coor !== null) {
            const coordinador = this.state.coordinadores.find(x => x.intIdPersona == coor.idPersona && x.idPrograma == coor.programa)
            /*console.log(coordinador)*/
            let idAsignados = this.state.asignados.length === 0 ? [] : this.state.asignados.map(x => x.valDetalle[0])
            //si programa es mayor que 0, es coordinador de posgrado; caso contrario el coordinador seleccionado es de grado
            let profesores = coor.programa > 0 ? this.state.profesores.filter(x => x.esPosgrado) : this.state.profesores.filter(x => x.esGrado)

            /*console.log('PROFESORES FILTRADO', profesores)*/
            const marcados = this.state.asignados.find(x => x.usuario.intIdPersona === coor.idPersona);
            /*console.log(marcados)*/
            this.setState({
                coordinador: coor, marcados: (typeof marcados === 'undefined' ? [] : marcados.valDetalle), profesoresMutar: profesores,
            })
            this.reLoadTotalPage(profesores.length, this.state.postsPerPage);
        } else {
            const marcados = this.state.asignados;
            this.setState({
                coordinador: coor, marcados: marcados === [] ? [] : marcados.map(x => x.valDetalle), profesoresMutar: this.state.profesores
            })
            this.reLoadTotalPage(this.state.profesores.length, this.state.postsPerPage);
        }

        //     console.log('Coordinador seleccionado' + coor.value))

    }

    changeFormat(fecha) {
        const date = fecha.split('T');
        //eXAMPLE
        //"2022-09-30"
        //"07:59:59"
        const [year, month, day] = date[0].split('-');
        const [hours, minutes, seconds] = date[1].split(':');

        var resp = new Date(+year, month - 1, +day, +hours, +minutes, +seconds);
        return resp;
    }

    toggleChange(event) {

        let { marcados } = this.state;
        /*console.log("CAMBIANDO ARREGLO MARCADOS", marcados)*/
        let idVal = parseInt(event.target.value)
        if (marcados.some(x => x === idVal)) {
            this.setState({ marcados: marcados.filter(x => x !== idVal) });
        } else {
            // this.setState({ marcados: [...this.state.marcados, idVal] });
            this.setState({ marcados: [...marcados, idVal] });
        }
    }

    toggleReactivar = (idVal) => {

        let { marcados } = this.state;
        /*console.log("CAMBIANDO ARREGLO MARCADOS", marcados)*/
        if (marcados.some(x => x === idVal)) {
            this.setState({ marcados: marcados.filter(x => x !== idVal) });
        } else {
            this.setState({ marcados: [...marcados, idVal] });
        }
    }

    toggleChangeAll = e => {
        //console.log(e)
        const { profesoresMutar, asignados, coordinador } = this.state;
        const idAsignados = asignados.length === 0 ? [] : asignados.filter(x => x.usuario.intIdPersona !== coordinador.idPersona).map(({ valDetalle }) => valDetalle).flat()
        let profesor = profesoresMutar.find(x => x.intIdPersona === parseInt(e.target.value))
        const validaciones = profesor.detalle.filter(x => !idAsignados.includes(x.idValDet)).map(x => x.idValDet)
        /*console.log("VALIDACIONES", validaciones)*/
        if (e.target.checked) {
            const resultado = Array.from(new Set([...this.state.marcados, ...validaciones]));
            /*console.log("SIUUU", resultado)*/
            this.setState({ marcados: resultado });
        } else {
            const resultado = this.state.marcados.filter(x => !validaciones.includes(x))
            /*console.log("NOUUU", resultado)*/
            this.setState({ marcados: resultado });
        }
    }

    handleSave(idProfesor) {
        let dto = {}
        this.setState({ block: true});
        dto['idValDetalle'] = this.state.marcados //modificar
        dto['idCoordinador'] = this.state.coordinador.idPersona
        dto['idProgramaSaacp'] = this.state.coordinador.programa
        const data = JSON.stringify(dto);
        /*console.log(data);*/
        fetch(local + 'Validacion/PostDelegacion', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: data,
        }).then((response) => {
            if (response.ok) {
                response.json().then(data => {
                    /*console.log(data)*/
                    this.setState(prevState => ({ profesores: data.value.profesores, coordinadores: data.value.coordinadores, asignados: data.value.usuarioAsignado, loading: false, profesoresMutar: prevState.profesoresMutar }))
                })
                this.reLoadTotalPage(this.state.profesoresMutar.length, this.state.postsPerPage);
                MySwal.fire({
                    icon: 'success',
                    title: 'Delegación completada',
                    text: 'Operacion exitosa!',
                    confirmButtonText: 'Listo',
                    timer: 5000
                })
                this.setState({ block: false });
            } else {
                // window.alert('fallo post')
                window.location.reload(false);
                this.setState({ block: false });
            }
        })
    }

    handleSaveAll() {
        let dto = {}
        this.setState({ block: true });
        dto['idValDetalle'] = this.state.marcados //modificar
        dto['idCoordinador'] = this.state.coordinador.idPersona
        dto['idProgramaSaacp'] = this.state.coordinador.programa
        const data = JSON.stringify(dto);
        /*console.log(data);*/
        MySwal.fire({
            icon: 'warning',
            title: 'Por favor espere!',
            html: 'Estamos procesando la consulta, esto puede tomar hasta 1 minuto.',// add html attribute if you want or remove
            allowOutsideClick: false,
            showCancelButton: false, 
            showConfirmButton: false,
            onOpen: () => {
                Swal.showLoading()
            },
        })
        fetch(local + 'Validacion/PostDelegacion', {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            method: 'POST',
            body: data,
        }).then((response) => {
            if (response.ok) {
                response.json().then(data => {
                    /*console.log(data)*/
                    this.setState(prevState => ({ profesores: data.value.profesores, coordinadores: data.value.coordinadores, asignados: data.value.usuarioAsignado, loading: false, profesoresMutar: prevState.profesoresMutar }))
                })
                MySwal.close();
                this.reLoadTotalPage(this.state.profesoresMutar.length, this.state.postsPerPage);
                MySwal.fire({
                    icon: 'success',
                    title: 'Delegación completada',
                    text: 'Operacion exitosa!',
                    confirmButtonText: 'Listo',
                    timer: 5000
                })
                this.setState({ block: false });
            } else {
                // window.alert('fallo post')
                MySwal.close();
                window.location.reload(false);
                this.setState({ block: false });
            }
        })
    }

    render() {

        let { profesoresMutar, coordinador, coordinadores, asignados, marcados, bandera } = this.state;
        const coordinadoresMutar = coordinadores.map(x => ({
            label: x.strApellidos + ' ' + x.strNombres + ' | ' + x.nombreCarrera,
            value: x.intIdPersona.toString() + x.idPrograma.toString(), programa: x.idPrograma, idPersona: x.intIdPersona
        }));

        let idAsignados = []
        if (coordinador === null)
            idAsignados = asignados.length === 0 ? [] : asignados.map(({ valDetalle }) => valDetalle).flat()
        else
            idAsignados = asignados.length === 0 ? [] : asignados.filter(x => x.usuario.intIdPersona !== coordinador.idPersona).map(({ valDetalle }) => valDetalle).flat()
        
        const coordinadorSelected = coordinador != null && coordinador.idPersona >= 0  
            ? coordinadores.find(x => x.intIdPersona == coordinador.idPersona && x.idPrograma == coordinador.programa) : null;

        const indexOfLastPost = this.state.currentPage * this.state.postsPerPage;

        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;

        const currentPosts = profesoresMutar.slice(indexOfFirstPost, indexOfLastPost);

        const pageNumbers = []

        for (let i = 1; i <= Math.ceil(profesoresMutar.length / this.state.postsPerPage); i++) {
            pageNumbers.push(i);
        }
        let noacceso = <Alert>Ha finalizado la fecha maxima para el acceso a el sistema.</Alert>
               

        return (
            <>
                {!bandera ? noacceso : <><div className="d-flex flex-row align-items-center py-1">
                    <h3><label style={{ color: '#243165', fontWeight: 'bold' }} > Delegaciones por área </label></h3>
                </div>
                <br></br>
                <h4><label style={{ color: '#243165', fontWeight: 'bold' }} > Coordinador: </label></h4>
                <Select
                    onChange={this.handleCoordinadorChange}
                    name="coordinadores"
                    options={coordinadoresMutar}
                    value={coordinador}

                    placeholder="Elija el coordinador"
                    className="basic-single"
                />
                <br />
                {this.state.loading ? <Spinner animation="border" /> : <></>}
                <div id="cartas">
                    <Row>
                       <div className='flex-box-2' hidden={currentPosts.length == 0}>
                         {this.state.coordinador !== null && this.state.coordinador.idPersona > 0 ?
                          <Button disabled={this.state.block} onClick={() => this.handleSaveAll()} className='btn-success btn-round btn-guardarVal'>
                                   {this.state.block ? <Spinner animation="grow" size="sm" /> : <>Guardar delegación</>}
                          </Button> : <></>
                         }
                       </div>
                    </Row>
                    <Row hidden={profesoresMutar.length === 0} id={'newPagination'}>
                        <Col xs="2">
                            
                        </Col>
                        <Col>
                            <Pagination hidden={pageNumbers.length < 1} >
                                <PaginationItem active={this.state.currentPage === 1} onClick={() => { this.setPage(1); }}>
                                    <PaginationLink>
                                        {1}
                                    </PaginationLink>
                                </PaginationItem>
                                <PaginationItem hidden={this.state.totalPageP < 5 || this.state.currentPage === 1} onClick={() => { this.setPagePrevious(); }}>
                                    <PaginationLink previous />
                                </PaginationItem>
                                {pageNumbers.map((page, i) =>
                                (
                                    <PaginationItem hidden={i + 1 === 1 || i + 1 === this.state.totalPageP || !this.setYouAreMySibling(i + 1)} active={this.state.currentPage === i + 1} onClick={() => { this.setPage(i + 1); }}>
                                        <PaginationLink>
                                            {i + 1}
                                        </PaginationLink>
                                    </PaginationItem>)
                                )}
                                <PaginationItem hidden={this.state.totalPageP < 5 || this.state.currentPage === this.state.totalPageP} onClick={() => { this.setPageNext(); }}>
                                    <PaginationLink next />
                                </PaginationItem>
                                <PaginationItem hidden={this.state.totalPageP === 1} active={this.state.currentPage === this.state.totalPageP} onClick={() => { this.setPage(this.state.totalPageP); }}>
                                    <PaginationLink>
                                        {this.state.totalPageP}
                                    </PaginationLink>
                                </PaginationItem>
                            </Pagination>
                        </Col>
                    </Row>
                    <Row>
                        {currentPosts.map(profesor =>
                            <Col sm="6">
                                <Card>
                                    <CardHeader>
                                        <Image src={"https://talentohumano.espol.edu.ec/imgEmpleado/" + profesor.strCedula + ".jpg"}
                                            onError={(e) => (e.target.onerror = null, e.target.src = images['user2.png'].default)}
                                            style={{ width: 60, height: 60, borderRadius: '50%', overflow: 'hidden', borderWidth: 3, borderColor: 'red', }} />
                                        <Button id={"tog" + profesor.intIdPersona} className="btnCard" style={{ width: "80%" }}>
                                            {profesor.strApellidos} {profesor.strNombres}
                                        </Button>
                                    </CardHeader>
                                    <UncontrolledCollapse toggler={"#tog" + profesor.intIdPersona}>
                                        <CardBody>
                                            <CardTitle className='checkboxesAll'>
                                                {this.state.coordinador !== null && this.state.coordinador.idPersona > 0 ?
                                                    <>
                                                        <label className={coordinadorSelected.esGrado ? "labelGrado" : "labelPosgrado"}>{coordinadorSelected.esGrado ? "GRADO" : "POSGRADO"}</label>
                                                        <br></br>
                                                        <div className='checkboxesAl'>
                                                            <label >
                                                                <input type="checkbox" defaultChecked={false} onClick={this.toggleChangeAll} value={profesor.intIdPersona} />
                                                                Select all
                                                            </label>
                                                        </div>
                                                    </>
                                                    : <></>}
                                            </CardTitle>
                                            <CardText>
                                                {profesor.detalle.filter(x => {
                                                    if (coordinador != null && coordinador.idPersona != 0) {
                                                        if (coordinador.programa > 0) {
                                                            return x.tipo == "M|P" || x.tipo == "A|P"
                                                        } else {
                                                            return x.tipo != "M|P" && x.tipo != "A|P"
                                                        }
                                                    } else {
                                                        return true
                                                    }
                                                }).map(validacion => {
                                                    return <Row className='rowCombo'>
                                                        {!idAsignados.includes(validacion.idValDet) ?
                                                            <Col sm="11">
                                                                <div className="checkboxes">
                                                                    <label>
                                                                        <input type="checkbox" checked={marcados.some(x => x === validacion.idValDet)} value={validacion.idValDet} onChange={this.toggleChange} />
                                                                        {validacion.actividad}
                                                                    </label>
                                                                </div>
                                                            </Col>
                                                            :
                                                            <>
                                                                <Col sm="11">
                                                                    <div className="checkboxes">
                                                                        <label style={{ color: "#ccc" }}>
                                                                            <input disabled type="checkbox" checked={marcados.some(x => x === validacion.idValDet)} value={validacion.idValDet} onChange={this.toggleChange} />
                                                                            {validacion.actividad}
                                                                        </label>
                                                                    </div>
                                                                </Col>
                                                                <Col sm="1">
                                                                    <img src={images['ReasignarACTIVO.svg'].default} alt="reactivar" style={{ cursor: "pointer" }} onClick={() => this.toggleReactivar(validacion.idValDet)} />
                                                                </Col>
                                                            </>
                                                        }
                                                    </Row>
                                                }

                                                )}
                                            </CardText>
                                            {/*{this.state.coordinador !== null && this.state.coordinador.idPersona > 0 ?*/}
                                            {/*    <Button disabled={this.state.block} onClick={() => this.handleSave(profesor.intIdPersona)} className='btn-success btn-round btn-guardarVal'>*/}
                                            {/*        */}{/*{this.state.block ? <Spinner animation="grow" size="sm" /> : <>Guardar delegación</>}*/}
                                            {/*        Guardar delegación*/}
                                            {/*    </Button> : <></>*/}
                                            {/*}*/}
                                        </CardBody>
                                    </UncontrolledCollapse>

                                </Card>
                            </Col>
                            )}
                            {currentPosts.length == 0 ?
                                <Alert color="danger" hidden={this.state.loading}>
                                 No hay profesores.
                                </Alert>
                            : <></>}
                    </Row>
                    <Row>
                       <div className='flex-box-2' hidden={currentPosts.length == 0}>
                          {this.state.coordinador !== null && this.state.coordinador.idPersona > 0 ?
                            <Button disabled={this.state.block} onClick={() => this.handleSaveAll()} className='btn-success btn-round btn-guardarVal'>
                                {this.state.block ? <Spinner animation="grow" size="sm" /> : <>Guardar delegación</>}
                            </Button> : <></>
                          }
                       </div>
                    </Row>
                </div>
            </>}</>
        )
    }
}
Delegar.contextType = AppContext;
export default Delegar;